<template>
<div>
	<div class="news">
		<div class="newTitle">{{info.title}}</div>
		<div class="time">{{info.create_time_text}}</div>
		<div class="con" v-html="info.content"></div>
	</div>
</div>
</template>

<script>
//const baseURL = 'https://api.test.laborhub.cn/'; // 测试环境
const baseURL = 'https://api.laborhub.cn/'; // 正式环境
import axios from 'axios';
export default {
		name: 'detail',
		props: {
			newsId:String
		},
	data() {
		return {
			info:{},
		};
	},
	onLoad(){
		
	},
	created() {
		window.scrollTo(0,0);
		this.getInfo();
	},
	methods: {
		async getInfo() {
			try {
			// 发起 GET 请求
				const response = await axios.get(baseURL+'openapi/news/info',{
							  params: {
								id: this.newsId
							  }
				});
				console.log(response);
				this.info = response.data.data;
			} catch (error) {
				console.error('请求失败:', error)
			} 
		},
	}
}
</script>

<style scoped>
@import './index.css';
</style>
